import { Box } from '@ouster/webviz-react-components';

import AdminOverallOrgsSummary from '../../components/adminDashboard/AdminOverallOrgsSummary';
import AdminOverallSummary from '../../components/adminDashboard/AdminOverallSummary';

export default function OrganizationLookUp() {
  return (
    <Box
      rowGap="1rem"
      display="grid"
      gridTemplateRows="auto 1fr"
      height="100%"
      overflow="hidden"
    >
      <AdminOverallSummary />
      <AdminOverallOrgsSummary />
    </Box>
  );
}
